import React from "react";

import "./toggleButton.scss";

export default function ToggleButton({
	label,
	className = "",
	checked,
	onClick,
	disabled,
}) {
	return (
		<button
			className={`toggleButton ${className} ${
				checked ? "checked" : "unchecked"
			}`}
			onClick={onClick}
			disabled={disabled}
		>
			<div>
				<span id="toggle" />
				<span id="background" className="border" />
			</div>
			<span id="label" className="h3 underlineHover">
				{label}
			</span>
		</button>
	);
}
